import { stringify } from 'query-string';

import { getRideBaseUrl } from '@/utility/getRideBaseUrl';

export type TRideUtm = {
  medium: string;
  campaign: string;
};

type TRideSearchUrlParams = {
  /** Free-text place name such as "Grapevine, Texas"; ride.auto geocodes it */
  city?: string;
  /** YYYY-MM-DD */
  pickup?: string;
  /** YYYY-MM-DD */
  return?: string;
  /** Minimum seatbelt count. ride.auto has no party-size filter, this is the closest fit. */
  minSeats?: number;
  petFriendly?: boolean;
  utm: TRideUtm;
};

const utmQuery = ({ medium, campaign }: TRideUtm) =>
  stringify({ utm_source: 'outdoorsy', utm_medium: medium, utm_campaign: campaign });

/**
 * Deep link into ride.auto's /car-search page, pre-filled from an Outdoorsy booking.
 * UTM params are appended by hand because the shared addUTMParams helper only
 * forwards them to Outdoorsy-owned hosts.
 */
export const buildRideSearchUrl = ({ utm, petFriendly, ...params }: TRideSearchUrlParams) => {
  const query = stringify(
    {
      ...params,
      // ride.auto reads `features` as a comma-separated list
      ...(petFriendly ? { features: 'pet_friendly' } : {}),
    },
    { skipNull: true, skipEmptyString: true },
  );

  return `${getRideBaseUrl()}/car-search?${query ? `${query}&` : ''}${utmQuery(utm)}`;
};

/**
 * Auto rentals come back from search with a slug already in ride.auto's
 * /car-rental/<location>/<slug> format, so the listing URL is just base + slug.
 */
export const buildRideListingUrl = (slug: string, utm: TRideUtm) =>
  `${getRideBaseUrl()}${slug}?${utmQuery(utm)}`;
